export const colors = {
  careHarm: '#F0E68C',            // Softer yellow (Khaki)
  fairnessCheating: '#DDA0DD',    // Softer pink (Plum)
  loyaltyBetrayal: '#87CEEB',     // Softer blue (Sky Blue)
  authoritySubversion: '#90EE90', // Softer green (Light Green)
  sanctityDegradation: '#FFA07A', // Softer orange (Light Salmon)
  libertyOppression: '#B19CD9'    // Softer purple (Light Purple)
};

export default colors;